// @flow

type SetWithSearchHeroAction = {
  type: 'SET_WITH_SEARCH_HERO',
  payload: {
    withSearchHero: boolean
  }
};

export type Action = SetWithSearchHeroAction;

export const setWithSearchHero = (
  withSearchHero: boolean
): SetWithSearchHeroAction => ({
  type: 'SET_WITH_SEARCH_HERO',
  payload: {
    withSearchHero
  }
});
